import { twMerge } from 'tailwind-merge';
import { MAX_QUANTITY, MIN_QUANTITY } from '@/constants/pricing';
import { MinusIcon, PlusIcon } from '@/icons';
import { classes } from './utils';

export interface QuantityStepperProps {
  className?: string;
  label?: string;
  value: number;
  onChange: (value: number) => void;
}

export default function QuantityStepper({
  className,
  label = 'Quantity',
  value,
  onChange,
}: QuantityStepperProps) {
  return (
    <div className={twMerge(classes.stepper, className)}>
      <button
        type="button"
        aria-label={`Decrease ${label.toLowerCase()}`}
        disabled={value <= MIN_QUANTITY}
        className={classes.button}
        onClick={() => onChange(value - 1)}>
        <MinusIcon size={14} />
      </button>
      <span className={classes.value}>{value}</span>
      <button
        type="button"
        aria-label={`Increase ${label.toLowerCase()}`}
        disabled={value >= MAX_QUANTITY}
        className={classes.button}
        onClick={() => onChange(value + 1)}>
        <PlusIcon size={14} />
      </button>
    </div>
  );
}
